import { Component, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Routes } from '@angular/router';
import { SmallshiService } from '../../services/smallshi.service';
import { LocationService } from '../../services/location.service';
import { DataDeliveryService } from '../../services/data-delivery.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent   {
  public idJsonPau = '';

  public idComercio = '';
  public etiquetasCom = '';
  public salesCode = '';
  public oops = false;
  public ecomerce = '';
  public rnc = '';
  public cedula = '';
  public flujo = '1';
  nuevasTiendas: any = {};
  finalizar: boolean = false;
  nuevasCategorias: any[] = [];
  id_inicial: string = '';
  totalTime = 3;
  public cateSelected: string = '';
  public location = {};
  public horarios: any[];
  public flagHorarios: boolean;
  public now: Date;


  constructor(private activateRoute: ActivatedRoute,
    private small: SmallshiService,
    private lct: LocationService,
    private delivery: DataDeliveryService) {
    this.activateRoute.params.subscribe(params => {
      // Nuevo modelo
      this.idJsonPau = params['id'];

      small.obtenerUrl(this.idJsonPau).subscribe((data: any) => {
        small.idCliente = data.data[0].id_Cliente;
        small.urlPau = data.data[0].url;
        small.nombreCliente = data.data[0].nameCli;
        small.emailCliente = data.data[0].email;
        small.telefonoCliente = data.data[0].telefono;
        small.formaEntrega = data.data[0].formaEntrega;
        small.urlRetorno = data.data[0].retorno;
        // console.log('small.urlRetorno: ', small.urlRetorno)
        small.flujo = this.flujo;
        this.salesCode = data.data[0].salesCode;
        this.rnc = data.data[0].RNC;
        this.cedula = data.data[0].cedula;
        this.idComercio = data.data[0].id_negocio;
        if (data.data[0].etiqueta === "" || data.data[0].etiqueta == null) {
          this.etiquetasCom = 'todos';
        } else {
          this.etiquetasCom = data.data[0].etiqueta;
        }

        if (this.idComercio) {
          this.getCategories();
          this.validaCliente();
        } else {
          this.oops = true;
          this.finalizar = false;
        }

      });

    });


  }
  cargaProductos(idCategoria: string) {
    this.cateSelected = idCategoria;
  }

  getCategories() {
    this.cateSelected = '';
    this.small.getCategories(this.idComercio, this.salesCode, this.etiquetasCom).subscribe((data: any) => {
      if (data.status) {
        this.nuevasCategorias = data.data;
        this.cateSelected = this.nuevasCategorias[0].category_id;
      } else {
        this.nuevasCategorias = [];
        Swal.fire({
          icon: 'error',
          title: 'Oops algo ocurrió...',
          text: data.message
        });
      }

    });
  }

  validaCliente() {
    this.small.createCliente(this.idComercio)
      .subscribe((resp: any) => {
        if(! resp.status) return console.error ('no se ha podido crear el cliente: ', resp)
        
        this.small.codCliente = resp.data[0].id;

      });
  }
  cerrarCatalogo(flagFinalizacion: boolean) {
    if (flagFinalizacion) {
      this.finalizar = flagFinalizacion;
      this.updateClock();
    } else {
      this.finalizar = false;
      this.oops = true;
    }

  }

  updateClock() {

    if (this.totalTime == 0) {
      this.cerrar();
    } else {
      this.totalTime -= 1;

      setTimeout(() => {
        this.updateClock();
      },
        1000);

    }
  }
  cerrar() {
    window.location.href = this.small.urlRetorno;
  }

  validarecomerce(tienda: any[]) {
    this.nuevasTiendas = tienda;
    this.nuevasTiendas.id = tienda['id'];
    if (this.nuevasTiendas.id) {
      this.small.controlDelivery = Number(this.nuevasTiendas.controlDelivery);

      this.now = new Date();
      this.small.getHorarios(this.nuevasTiendas.id).subscribe((horarios: any) => {
        this.horarios = horarios.data;
        const index_horario = (element) => this.now <= new Date(this.now.getUTCFullYear(), this.now.getMonth(), this.now.getDate(), element.hora.substr(0, 2), element.hora.substr(3, 2), element.hora.substr(6, 2));
        if (this.horarios.findIndex(index_horario) !== -1) {
          this.small.idhentrega = this.horarios[this.horarios.findIndex(index_horario)].id;
          this.flagHorarios = true;
        } else {
          this.flagHorarios = false;
          Swal.fire({
            icon: 'info',
            text: `No hay horario de reparto para hoy.`
          });
        }
        if (this.flagHorarios) {
          this.ecomerce = this.nuevasTiendas.ecommerce;
        } else this.ecomerce = '0';
      });
    }
  }

  cortar(cadena: string, cantidad: number) {
    return (cadena.length > cantidad ? cadena.substring(0, cantidad) + "..." : cadena);
  }
  buscarProductos() {
    this.small.filtroHtml = ((document.getElementById("buscadorHtml") as HTMLInputElement).value);
    this.getCategories();
  }
}
